import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X, ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María José G.',
  city: 'Buenos Aires'
}, {
  name: 'Sofía L.',
  city: 'Córdoba'
}, {
  name: 'Martín R.',
  city: 'Rosario'
}, {
  name: 'Camila B.',
  city: 'Mendoza'
}, {
  name: 'Lucía P.',
  city: 'La Plata'
}, {
  name: 'Florencia M.',
  city: 'Mar del Plata'
}, {
  name: 'Agustina D.',
  city: 'San Miguel de Tucumán'
}, {
  name: 'Valeria T.',
  city: 'Salta'
}, {
  name: 'Carolina S.',
  city: 'Neuquén'
}, {
  name: 'Juliana A.',
  city: 'Bahía Blanca'
}, {
  name: 'Romina C.',
  city: 'Santa Fe'
}, {
  name: 'Pablo H.',
  city: 'San Juan'
}, {
  name: 'Daniela V.',
  city: 'Resistencia'
}, {
  name: 'Brenda F.',
  city: 'Posadas'
}, {
  name: 'Micaela O.',
  city: 'Río Cuarto'
}, {
  name: 'Gabriela N.',
  city: 'Paraná'
}, {
  name: 'Verónica E.',
  city: 'San Luis'
}, {
  name: 'Marina I.',
  city: 'Quilmes'
}, {
  name: 'Antonella Z.',
  city: 'Bariloche'
}, {
  name: 'Tamara J.',
  city: 'Corrientes'
}];
const offers = ['Sistema Completo Sin Gluten', 'Recetas Saludables para Celíacos'];
interface Notification {
  id: number;
  name: string;
  city: string;
  offer: string;
  minutesAgo: number;
}
function randomPick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function randomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export function PurchasePopup() {
  const [notification, setNotification] = useState<Notification | null>(null);
  useEffect(() => {
    let showTimeout: ReturnType<typeof setTimeout>;
    let hideTimeout: ReturnType<typeof setTimeout>;
    let idCounter = 0;
    const showNotification = () => {
      const newNotification: Notification = {
        id: ++idCounter,
        name: randomPick(buyers).name,
        city: randomPick(buyers).city,
        offer: randomPick(offers),
        minutesAgo: randomInt(1, 9)
      };
      setNotification(newNotification);
      // Hide after ~7 seconds
      hideTimeout = setTimeout(() => {
        setNotification(null);
        // Schedule next one between 40s and 60s after hiding
        showTimeout = setTimeout(showNotification, randomInt(40, 60) * 1000);
      }, 7000);
    };
    // First notification appears 10 seconds after page load
    showTimeout = setTimeout(showNotification, 10000);
    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, []);
  const handleClose = () => {
    setNotification(null);
  };
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" data-id="element-175">
      <AnimatePresence data-id="element-176">
        {notification && <motion.div key={notification.id} initial={{
        opacity: 0,
        x: -40,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -40,
        y: 20
      }} transition={{
        duration: 0.45,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="pointer-events-auto max-w-xs sm:max-w-sm bg-white border border-brand-100 rounded-2xl shadow-soft-lg p-4 flex items-start gap-3 relative" role="status" aria-live="polite" data-id="element-177">
            <div className="relative flex-shrink-0" data-id="element-178">
              <div className="w-11 h-11 rounded-full bg-brand-100 flex items-center justify-center" data-id="element-179">
                <ShoppingBag className="w-5 h-5 text-brand-600" data-id="element-180" />
              </div>
              <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-white flex items-center justify-center" data-id="element-181">
                <CheckCircle2 className="w-5 h-5 text-brand-500 fill-brand-100" data-id="element-182" />
              </div>
            </div>

            <div className="flex-1 min-w-0 pr-4" data-id="element-183">
              <p className="text-sm text-brand-950 leading-snug" data-id="element-184">
                <span className="font-bold" data-id="element-185">{notification.name}</span>
                <span className="text-brand-700" data-id="element-186"> de {notification.city}</span>
              </p>
              <p className="text-xs text-brand-700 mt-0.5 leading-snug" data-id="element-187">
                acaba de comprar{' '}
                <span className="font-semibold text-brand-800" data-id="element-188">
                  {notification.offer}
                </span>
              </p>
              <div className="flex items-center gap-1.5 mt-1.5" data-id="element-189">
                <span className="w-1.5 h-1.5 rounded-full bg-brand-500 animate-pulse" data-id="element-190"></span>
                <span className="text-[11px] text-brand-500 font-medium" data-id="element-191">
                  Compra verificada · hace {notification.minutesAgo}{' '}
                  {notification.minutesAgo === 1 ? 'minuto' : 'minutos'}
                </span>
              </div>
            </div>

            <button onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-brand-400 hover:text-brand-700 transition-colors p-1 rounded-full hover:bg-brand-50" data-id="element-192">
              <X className="w-3.5 h-3.5" data-id="element-193" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}